import { Icon, IconProps } from '@chakra-ui/react'
import { FiCheck } from 'react-icons/fi'

export function CheckIcon(props: IconProps) {
  return <Icon as={FiCheck} {...props} />
}
